import React, { SyntheticEvent } from 'react'
import { connect } from 'react-redux'
import { createDocumentGdrive } from '../actions/documents'
import { tagFunnel } from '../actions/tagmanager'
import { DispatchThunk } from '../actions/types'
import Button from '../components/base/Button'
import Icon from '../components/base/Icon'
import { GDRIVE } from '../util/dataTestIds'
import DocumentTextarea from './DocumentTextarea'
import DocumentUploadBtn from './DocumentUploadBtn'
import ErrorMessage from './ErrorMessages'
import styles, { paperUploadUi, title, subText, p, legal } from './UploadOptions.css'
import { WtaiUploadWidgetProps, CENTER } from '../types'

type Props = Pick<WtaiUploadWidgetProps, 'headingText' | 'subheadingText' | 'pasteOnly' | 'alignText'>

interface DispatchProps {
  openCheckModal: (e: SyntheticEvent) => void
}

interface StateProps {
  initialized: boolean
}

export type UploadOptionsProps = Props & DispatchProps & StateProps

const DEFAULT_HEADING = 'Try our smart proofreader'
const DEFAULT_SUB = `Don't worry, your writing won't be searchable publicly or in any other database. No other plagiarism checkers will see your paper.`

export const UploadOptions: React.FunctionComponent<UploadOptionsProps> = ({
  openCheckModal,
  initialized,
  pasteOnly,
  headingText = DEFAULT_HEADING,
  subheadingText = DEFAULT_SUB,
  alignText = CENTER,
}) => {
  const textAlignClass = styles[`align-${alignText}`]

  return (
    <div className={paperUploadUi}>
      <h1 className={[title, textAlignClass].join(' ')}>{headingText}</h1>
      <h2 className={[subText, textAlignClass].join(' ')}>{subheadingText}</h2>
      <form className={styles.uploadOptions}>
        <DocumentTextarea initialized={initialized} />
        <div className="paper-entry text-center">
          {!pasteOnly && <p className={p}>or import your paper</p>}
          {initialized && !pasteOnly && <ErrorMessage />}
          {!pasteOnly && (
            <div className={styles.uploadButtonsWrapper}>
              <DocumentUploadBtn />
              <Button
                inverted
                halfWidth
                disabled={!initialized}
                data-id="gDriveUpload"
                data-test-id={GDRIVE}
                onClick={e => openCheckModal(e)}
                type="button"
              >
                <Icon name="google-drive" size="16" />
                <span>It&apos;s on Google Drive &trade;</span>
              </Button>
            </div>
          )}
          <small className={legal}>
            The papers you upload will be added to our plagiarism database and will be used internally to improve
            plagiarism results.
          </small>
        </div>
      </form>
    </div>
  )
}

const mapStateToProps = (state: any) => ({
  initialized: state.app.initialized,
})

const mapDispatchToProps = (dispatch: DispatchThunk) => ({
  openCheckModal: (e: SyntheticEvent) => {
    e.preventDefault()
    dispatch(createDocumentGdrive())
    dispatch(tagFunnel('upload paper', 'on google drive'))
  },
})

export default connect<StateProps, DispatchProps>(mapStateToProps, mapDispatchToProps)(UploadOptions)
